import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import { PDiPModeltypebasicDto } from 'src/services/Client';

export interface IDerivatesState {
  /** colors for modeltypes */
  modeltypeColors: string[];

  /** PDiP modeltype basic data */
  modeltypebasicPDiPList: PDiPModeltypebasicDto[];
}

const INITIAL_STATE: IDerivatesState = {
  modeltypeColors: [],
  modeltypebasicPDiPList: [],
};

export const derivateReducer = (
  state: IDerivatesState = INITIAL_STATE,
  action: AnyAction
): IDerivatesState => {
  switch (action.type) {
    case ActionTypes.SET_MODELTYPE_COLORS:
      return {
        ...state,
        modeltypeColors: action.data,
      };
    case ActionTypes.SET_MODELTYPEBASIC_PDIP_LIST:
      return {
        ...state,
        modeltypebasicPDiPList: action.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/derivatesReducer.ts